import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { appService } from '../../../_services/app.service';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { Helpers } from '../../../helpers';
import { ConfirmationPopupComponent } from '../../components/confirmation-popup/confirmation-popup.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class NetworkService {
      companyParentList: any[];
      financialYearList: any[];
      currencyList: any[];
      vehicleConditionList: any[];
      vehicleBodyTypeList: any[];
      classOfVehicleList: any[];
      vehicleFuelUsedLlist: any[];
      axleTypeList: any[];
      vehicleTypeList: any[];
      vehicleStatusTypeList: any[];
      companyList: any[];
      timeIntervalTypeList: any[];
      vehicleInsuranceTypeList: any[];
      gasKitTypeList: any[];
      vehiclePermitTypeList: any[];
      tyresMasterPositionList: any[];
      reeferTypeList: any[];
      vehicleAccountTypeList: any[];
      serviceList: any[];
      SalesPerson: any[];
      ContractStatus: any[];
      constructor(private _appService: appService, private translate: TranslateService,
            private toastr: ToastrService, private datePipe: DatePipe, private modalService: NgbModal) { }

      getCompanyParentList(userId): Promise<any> {
            return new Promise((resolve, reject) => {
                  this._appService
                        .GetById("Company", "GetParentCompanyList", userId).subscribe(
                              (response) => {
                                    if (response) {
                                          response.map(x => {
                                                x.name = x.Label;
                                                x.value = x.Id;
                                          })
                                    }
                                    this.companyParentList = response;
                                    resolve(response);
                              },
                              (err) => {
                                    this.toastr.error(
                                          "Error occurred while fetching Driver type !",
                                          "error"
                                    );
                                    reject(err);

                              }
                        );
            })
      }

      getFinancialYearList(): Promise<any> {
            return new Promise((resolve, reject) => {
                  this._appService
                        .GetById("Common", "GetLookByCategoryName", 'FinancialYear')
                        .subscribe(
                              (response) => {
                                    if (response) {
                                          response.map(x => {
                                                x.name = x.Label;
                                                x.value = x.Id;
                                          })
                                    }
                                    this.financialYearList = response;
                                    resolve(response);
                              },
                              (err) => {
                                    this.toastr.error(
                                          "Error occurred while fetching Driver type !",
                                          "error"
                                    );
                                    reject(err);

                              }
                        );
            });
      }

      getRegistrationDocumentList(param): Promise<any> {
            return new Promise((resolve, reject) => {
                  this._appService
                        .GetByTwoId("Common", "GetLookByCategoryName", 'RegistrationDocuments', param)
                        .subscribe(
                              (response) => {

                                    if (response) {
                                          response.map(x => {
                                                x.name = x.Label;
                                                x.value = x.Id;
                                          })
                                    }
                                    this.financialYearList = response;
                                    resolve(response);
                              },
                              (err) => {
                                    this.toastr.error(
                                          "Error occurred while fetching Driver type !",
                                          "error"
                                    );
                                    reject(err);

                              }
                        );
            });
      }

      getCurrencyList(): Promise<any> {
            return new Promise((resolve, reject) => {
                  this._appService
                        .GetById("Common", "GetLookByCategoryName", 'Currency')
                        .subscribe(
                              (response) => {

                                    if (response) {
                                          response.map(x => {
                                                x.name = x.Label;
                                                x.value = x.Id;
                                          })
                                    }
                                    this.currencyList = response;
                                    resolve(response);
                              },
                              (err) => {
                                    this.toastr.error(
                                          "Error occurred while fetching Driver type !",
                                          "error"
                                    );
                                    reject(err);

                              }
                        );
            });
      }

      getCompanyList(TenantId): Promise<any> {
            return new Promise((resolve, reject) => {
                  this._appService
                        .GetById("User", "GetCompanyList", TenantId)
                        .subscribe(
                              (response) => {

                                    if (response) {
                                          response.map(x => {
                                                x.name = x.Label;
                                                x.value = x.Id;
                                          })
                                    }
                                    this.companyList = response;
                                    resolve(response);
                              },
                              (err) => {
                                    this.toastr.error(
                                          "Error occurred while fetching Driver type !",
                                          "error"
                                    );
                                    reject(err);

                              }
                        );
            });
      }


      // getTransportServiceType(): Promise<any> {
      //       return new Promise((resolve, reject) => {
      //             this._appService
      //                   .Get("Company", "GetTransportTypesList")
      //                   .subscribe(
      //                         (response) => {
      //                               
      //                               if (response) {
      //                                     response.Results.map(x => {
      //                                           x.name = x.Label;
      //                                           x.value = x.id;
      //                                     })
      //                               }
      //                               this.serviceList = response.Results;
      //                               resolve(response.Results);
      //                               return response.Results;
      //                         },
      //                         (err) => {
      //                               this.toastr.error(
      //                                     "Error occurred while fetching Driver type !",
      //                                     "error"
      //                               );
      //                               reject(err);
      //                         }
      //                   );
      //       })
      // }
      getTransportServiceType(): Promise<any> {
            return new Promise((resolve, reject) => {
                  this._appService
                        .Get("Company", "GetTransportTypesList",)
                        .subscribe(
                              (response) => {

                                    if (response) {
                                          response.map(x => {
                                                x.name = x.Label;
                                                x.value = x.Id;
                                          })
                                    }
                                    this.serviceList = response;
                                    resolve(response);
                                    return response;
                              },
                              (err) => {
                                    this.toastr.error(
                                          "Error occurred while fetching Driver type !",
                                          "error"
                                    );
                                    reject(err);
                              }
                        );
            })
      }


      getDeliveryPartner(data): Promise<any> {
            return new Promise((resolve, reject) => {
                  this._appService
                        .Post("Network", "GetNetworkCardData", data)
                        .subscribe(
                              (response) => {

                                    if (response) {
                                          response.map(x => {
                                                x.name = x.CompanyName;
                                                x.value = x.Id;
                                          })
                                    }
                                    this.vehicleAccountTypeList = response;
                                    resolve(response);
                                    return response;
                              },
                              (err) => {
                                    this.toastr.error(
                                          "Error occurred while fetching Driver type !",
                                          "error"
                                    );
                                    reject(err);
                              }
                        );
            })
      }

      getNetworkType(): Promise<any> {
            return new Promise((resolve, reject) => {
                  this._appService
                        .GetById("Common", "GetLookByCategoryName", "CompanyType")
                        .subscribe(
                              (response) => {

                                    if (response) {
                                          response.map(x => {
                                                const label = x.Label === 'Self' ? 'Contracted - Self' :
                                                      (x.Label === 'Attached' ? 'Other-Attached' : 'Retail - Hired');
                                                x.name = label;
                                                x.value = x.Id;
                                          })
                                    }
                                    this.vehicleAccountTypeList = response;
                                    resolve(response);
                                    return response;
                              },
                              (err) => {
                                    this.toastr.error(
                                          "Error occurred while fetching Driver type !",
                                          "error"
                                    );
                                    reject(err);
                              }
                        );
            })
      }

      deleteNetworkDetailsById(Id): Promise<any> {
            return new Promise((resolve) => {
                  const dialogRef = this.modalService.open(ConfirmationPopupComponent, { centered: true });
                  dialogRef.componentInstance.details = {
                        message: 'Are you sure you want to delete this network?',
                        title: 'Confirmation',
                  }
                  dialogRef.componentInstance.close.subscribe((res: any) => {
                        if (res) {
                              Helpers.setLoading(true);
                              this._appService.Delete("Network", "DeleteNetworkCompany", Id).subscribe(response => {
                                    let resSTR = JSON.stringify(response);
                                    let resJSON = JSON.parse(resSTR);
                                    if ((resJSON._body == 2)) {
                                          this.toastr.warning(
                                                "Can't delete becuase transactions are exists in booking"
                                          );
                                    } else if ((resJSON._body == 3)) {
                                          this.toastr.warning(
                                                "Can't delete becuase transactions are exists in Reminders "
                                          );
                                    } else {
                                          this.toastr.success(
                                                "Detail Deleted Successfully !",
                                                "Success"
                                          );
                                          resolve(1);
                                    }
                                    Helpers.setLoading(false);
                              }, err => {
                                    Helpers.setLoading(false);
                                    this.toastr.error("An error occured while deleting data !", 'error');
                              });
                        }
                        dialogRef.close();
                  });
            })
      }
      GetSalesPerson(): Promise<any> {
            return new Promise((resolve, reject) => {
                  this._appService
                        .GetById("AccountingReport", "GetSalesPerson", '%%')
                        .subscribe(
                              (response) => {

                                    // if (response) {
                                    //       response.map(x => {
                                    //             x.name = x.name;
                                    //             x.value = x.value;
                                    //       })
                                    // }
                                    this.SalesPerson = response;
                                    resolve(response);
                                    return response;
                              },
                              (err) => {
                                    this.toastr.error(
                                          "Error occurred while fetching Driver type !",
                                          "error"
                                    );
                                    reject(err);
                              }
                        );
            })
      }
      deleteOrderById(Id): Promise<any> {
            return new Promise((resolve) => {
                  const dialogRef = this.modalService.open(ConfirmationPopupComponent, { centered: true });
                  dialogRef.componentInstance.details = {
                        message: 'Are you sure you want to delete this Order?',
                        title: 'Confirmation',
                  }
                  dialogRef.componentInstance.close.subscribe((res: any) => {
                        if (res) {
                              Helpers.setLoading(true);
                              this._appService.Delete("OrdersByVehicle", "DeleteVehicleOrders", Id).subscribe(response => {
                                    let resSTR = JSON.stringify(response);
                                    let resJSON = JSON.parse(resSTR);
                                    if ((resJSON._body == 1)) {
                                          this.toastr.success(
                                                "Detail Deleted Successfully !",
                                                "Success"
                                          );
                                    }
                                    Helpers.setLoading(false);
                              }, err => {
                                    Helpers.setLoading(false);
                                    this.toastr.error("An error occured while deleting data !", 'error');
                              });
                        }
                        dialogRef.close();
                  });
            })
      }
      CancelOrderById(CancelOrderId, Reason, UserId): Promise<any> {
            return new Promise((resolve) => {
                  const dialogRef = this.modalService.open(ConfirmationPopupComponent, { centered: true });
                  dialogRef.componentInstance.details = {
                        message: 'Are you sure you want to cancel this Order?',
                        title: 'Confirmation',
                  }
                  dialogRef.componentInstance.close.subscribe((res: any) => {
                        if (res) {
                              Helpers.setLoading(true);
                              this._appService
                                    .GetByThreeId(
                                          "OrdersByVehicle",
                                          "CancelVehicleOrders",
                                          CancelOrderId,
                                          Reason,
                                          UserId
                                    ).subscribe(response => {
                                          let resSTR = JSON.stringify(response);
                                          let resJSON = JSON.parse(resSTR);
                                          if ((resJSON._body == 1)) {
                                                this.toastr.success(
                                                      "Detail Deleted Successfully !",
                                                      "Success"
                                                );
                                          }
                                          Helpers.setLoading(false);
                                    }, err => {
                                          Helpers.setLoading(false);
                                          this.toastr.error("An error occured while deleting data !", 'error');
                                    });
                        }
                        dialogRef.close();
                  });
            })
      }


      //   GetContractStatus() {
      //       this._appService
      //             .Get("Carrier", "GetContractStatus")
      //             .subscribe((Response) => {
      //             this.ContractStatus = Response;
      //             });
      //       }

      getContractStatus(): Promise<any> {
            return new Promise((resolve, reject) => {
                  this._appService
                        .Get("Carrier", "GetContractStatus",)
                        .subscribe(
                              (response) => {

                                    if (response) {
                                          response.map(x => {
                                                x.name = x.StatusName;
                                                x.value = x.Id;
                                          })
                                    }
                                    this.ContractStatus = response;
                                    resolve(response);
                                    return response;
                              },
                              (err) => {
                                    this.toastr.error(
                                          "Error occurred while fetching Driver type !",
                                          "error"
                                    );
                                    reject(err);
                              }
                        );
            })
      }

}